<app-dialog
  #dialog
  [key]="'deal-decision'"
  [action]="'deal-decision'"
  [headerTheme]="'simple'"
  [maxWidth]="'560px'"
  [hideDefaultFooter]="true">
  <!-- Cabeçalho próprio: o subtítulo diz SOBRE QUAL deal a decisão vai cair. É a conferência que
       a pessoa faz antes de uma ação que dispara e-mail para o parceiro. -->
  <ng-template #title>
    <div class="decision-head">
      <span
        class="decision-head__icon"
        [class.decision-head__icon--danger]="rejeitando"
        aria-hidden="true">
        <i [class]="rejeitando ? 'pi pi-times-circle' : 'pi pi-replay'"></i>
      </span>
      <div class="decision-head__texts">
        <p class="decision-head__eyebrow">Decisão da Legatus</p>
        <h4 class="decision-head__title">{{ titulo }}</h4>
        <p class="decision-head__subtitle">
          {{ deal?.corporateName }}
          @if (deal?.cnpj) {
            · CNPJ {{ deal!.cnpj | vaultMaskCnpj }}
          }
        </p>
      </div>
    </div>
  </ng-template>

  <!-- `appAutoFormGroup` obrigatório junto do `[formGroup]`: sem ele o `app-input` cria controle
       próprio e o formulário nasce vazio, com o botão travado e nenhum erro no console. -->
  <div class="decision-modal" [formGroup]="form" appAutoFormGroup>
    <p class="decision-notice">
      <i class="pi pi-info-circle" aria-hidden="true"></i>
      <span>
        @if (rejeitando) {
          O parceiro recebe um e-mail com o que você escrever aqui, e o texto fica na linha do tempo
          do deal. <strong>A etapa não muda</strong> — o deal fica registrado onde parou, para poder
          ser reaberto de lá.
        } @else {
          A rejeição <strong>não some</strong>: ela continua na linha do tempo, ao lado desta
          justificativa.
          @if (reopensToAnalysis) {
            O deal foi negado pelo comitê de crédito: volta para <strong>Análise</strong>, para ser
            enviado ao comitê numa nova rodada.
          } @else {
            O deal volta exatamente para a etapa em que estava.
          }
        }
      </span>
    </p>

    @if (rejeitando) {
      <app-select
        [label]="'Motivo'"
        [options]="motivos"
        [required]="true"
        [placeholder]="'Selecione o motivo'"
        formControlName="reason" />
    }

    <app-input
      [type]="'textarea'"
      [label]="rotuloDoTexto"
      [placeholder]="exemploDoTexto"
      [required]="true"
      [textCenter]="false"
      formControlName="notes" />

    <!-- O mínimo de caracteres não é capricho: "não deu" é tecnicamente um texto, e chega ao
         parceiro como uma rejeição sem explicação — que volta como pergunta. -->
    @if (form.get('notes')?.touched && form.get('notes')?.hasError('minlength')) {
      <p class="decision-erro">Escreva ao menos uma frase — o parceiro só tem este texto.</p>
    }
  </div>

  <ng-template #footer>
    <div class="decision-foot">
      <p class="decision-foot__note">
        <i class="pi pi-envelope" aria-hidden="true"></i>
        <span>Quem registrou o deal é avisado por e-mail.</span>
      </p>

      <div class="decision-foot__actions">
        <app-button
          [label]="'Cancelar'"
          [theme]="'outline-grey'"
          [type]="'button'"
          (sendButtonClick)="fechar()"></app-button>
        <app-button
          [disabled]="!isFormValid()"
          [isLoading]="gravando"
          [loadingText]="'Enviando...'"
          [label]="rotuloDoBotao"
          [theme]="rejeitando ? 'danger' : 'default'"
          [type]="'button'"
          (sendButtonClick)="submitAction()"></app-button>
      </div>
    </div>
  </ng-template>
</app-dialog>
